import { render, staticRenderFns } from "./ReferenceCard.vue?vue&type=template&id=292f37ec&scoped=true&"
import script from "./ReferenceCard.vue?vue&type=script&lang=js&"
export * from "./ReferenceCard.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCard.vue?vue&type=style&index=0&id=292f37ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f37ec",
  null
  
)

export default component.exports